/**
 * @file useElementBoundary
 * @author yuzong(yuzong@tencent.com)
 */
import { useRef } from 'react';
import { useElementMutation } from '@tencent/glue-react-mutation';
import { getDefaultElementBoundary, isElementBoundaryEqual } from '@tencent/glue-util-boundary';
import { getElementBoundary } from '@tencent/glue-dom-boundary';
export function useElementBoundary(isEnable, onChange, options) {
  var positionRef = useRef(getDefaultElementBoundary());
  return useElementMutation(isEnable, function (elem, init) {
    var boundary = getElementBoundary(elem);

    if (init || !isElementBoundaryEqual(positionRef.current, boundary)) {
      positionRef.current = boundary;
      onChange && onChange(boundary, init);
    }
  }, options);
}